/* 🤖 this file was generated by script */
export const wiconUserPlus02 = {
  name: 'user_plus_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 10V4m-3 3h6m-6 14v-1.2c0-1.68 0-2.52-.33-3.16a3 3 0 00-1.3-1.31C13.71 15 12.87 15 11.2 15H6.8c-1.68 0-2.52 0-3.16.33a3 3 0 00-1.31 1.3C2 17.29 2 18.13 2 19.8V21M12.5 7.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z"/></svg>`,
};
